import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

const TermsAndConditions = () => {
  return (
    <div>
        <Header />
        <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
            <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Términos y Condiciones</h1>
            <p>
                Está usted accediendo a la Aplicación <strong>"Hoy Toca Recetas"</strong> (en adelante “App”) 
                de Grupo Herdez, S.A.B. de C.V. (en lo sucesivo “Grupo Herdez”).
            </p>
            <p>
                Por favor lea cuidadosamente los Términos y Condiciones Legales que regulan el acceso y uso por parte 
                de los usuarios (el “Usuario” o “Usuarios”) de la App de Grupo Herdez y/o afiliadas y/o subsidiarias y/o 
                cualquier página y/o aplicación de las marcas pertenecientes a Grupo Herdez; ya que el acceso y uso de 
                la App atribuye la condición de Usuario del mismo y constituye el entendimiento y la aceptación de los 
                Términos y Condiciones Legales aquí establecidos.
            </p>
            <p>
                Esta App puede ser visitada por cualquier Usuario de forma libre y gratuita sujeto a los presentes 
                Términos y Condiciones Legales.
            </p>
            <p>
                El contenido de esta App tiene como finalidad dar a conocer al Usuario, información general relacionada 
                con Grupo Herdez y/o afiliadas y/o subsidiarias, lo cual no implica ni garantiza que la información aquí 
                contenida pueda satisfacer los requisitos de precisión, detalle o exactitud requerida a juicio del Usuario. 
                En tal virtud, el contenido es de índole informativo, por lo que la interpretación es personal de cada Usuario.
            </p>
            <p>
                El Usuario declara bajo protesta de decir verdad ser mayor de edad, para lo cual deberá de ingresar su fecha 
                de nacimiento en el proceso de registro de la App; Grupo Herdez podrá solicitar al Usuario compruebe su identidad 
                mediante identificación oficial con fotografía. En caso de que el Usuario mienta en sus datos al momento de registrarse 
                en la App y resulte que es menor de edad, Grupo Herdez tendrá el derecho de dar de baja su registro, perdiendo todo 
                derecho a que pudiera ser acreedor, por haber falseado datos en el momento de su registro.
            </p>
            <p>
                Grupo Herdez no asume responsabilidad alguna, derivada de que la Información disponible en esta App no sea precisa o 
                completa y se reserva el derecho de modificar el contenido de la App en cualquier momento y sin previo aviso al Usuario, 
                incluyendo los presentes Términos y Condiciones Legales. Las modificaciones que se hagan producirán efecto en forma 
                inmediata a su incorporación en la App.
            </p>
            <p>
                La información de esta App es en relación a los productos e información exclusiva en los Estados Unidos Mexicanos, 
                debiendo considerarse como una App de compra, beneficios y recompensas donde los Usuarios pueden adquirir productos 
                de Grupo Herdez dentro del territorio nacional. Por lo anterior, la información contenida en la App es aplicable 
                dentro del territorio de los Estados Unidos Mexicanos y Grupo Herdez no garantiza que la misma cumpla con la 
                legislación de otros países, por lo que, el Usuario es el único responsable de cumplir con las leyes locales que 
                le apliquen si ingresa a la App desde cualquier lugar fuera de los Estados Unidos Mexicanos.
            </p>
            <p>
                Al accesar a esta App, el Usuario acepta y reconoce que Grupo Herdez no es responsable en ningún momento por la 
                incomunicación, interrupción, falla o inhabilitación de la App por causas no imputables a Grupo Herdez; así como 
                que no será tampoco responsable de cualquier daño o perjuicio, de manera enunciativa pero no limitativa, por fallas 
                técnicas de cualquier tipo, incluyendo daños en el equipo personal de cómputo, teléfono móvil, tablet y/o cualquier 
                dispositivo utilizado por los Usuarios para ingresar a la App o por experimentar o apreciar los materiales relacionados 
                con el mismo, por intervención humana no autorizada, por retrasos, distorsiones o interferencias en las transmisiones 
                telefónicas o de computadora u otros errores de cualquier tipo, ya sea humanos, electrónicos o mecánicos. En el mismo 
                sentido, Grupo Herdez no tendrá responsabilidad alguna por cualquier pérdida causada por virus que puedan infectar a su 
                computadora u otra propiedad por razón de usar, ingresar o bajar cualquier material de esta App. Si el Usuario elige 
                descargar materiales de la App siempre será bajo su propio riesgo y cualquier mal uso o uso incorrecto de la información 
                será exclusivamente su responsabilidad.
            </p>
            <p>
                Toda la información como pueden ser, de forma enunciativa mas no limitativa: Imágenes, Videos, Textos, Marcas Registradas, 
                Productos, Avisos Comerciales, Nombres de Dominio y Diseños, Reportes, Políticas, Comunicados de Prensa, Historia de Grupo 
                Herdez y demás análogos (referidos en el presente documento como “Información”) contenidas en esta App, pueden ser propiedad 
                de Grupo Herdez, sus titulares y/o licenciatarios, estando por ende protegida por los convenios internacionales y la legislación 
                mexicana en materia de propiedad industrial e intelectual.
            </p>
            <p>
                Ningún contenido de esta App debe interpretarse como un otorgamiento de licencia de uso o derecho de uso de la Información 
                mostrada, por lo que se prohíbe cualquier uso, reproducción total o parcial de la Información o cualquier contenido del mismo.
            </p>
            <p>
                El Usuario se obliga a usar la App, sus contenidos y/o servicios de forma diligente y de conformidad con los presentes 
                Términos y Condiciones Legales; así como con la ley, la moral, el orden público y las buenas costumbres.
            </p>
            <p>
                Grupo Herdez se reserva el absoluto derecho de denegar o retirar el acceso a la App y/o a los servicios aquí contenidos, en 
                cualquier momento y sin necesidad de previo aviso, al Usuario que no cumpla con lo establecido en los presentes Términos 
                y Condiciones Legales.
            </p>
            <p>
                Asimismo, Grupo Herdez se reserva el derecho de restringir, finalizar o terminar el ingreso a esta App, al Usuario que intente 
                dañar o alterar deliberadamente a la App o cualquiera de sus secciones, estropear, modificar o impedir la legítima operación 
                del mismo, por lo que constituye una violación a las Leyes Federales y Locales, reservándose Grupo Herdez el derecho de actuar 
                por la vía Civil y/o Penal y/o cualquier otra, con la finalidad de reclamar la reparación del daño y la correspondiente 
                indemnización por Daños y Perjuicios.
            </p>
        </div>
        <Footer />
    </div>
    
  );
};

export default TermsAndConditions;
